import { render } from "./grid-column.vue?vue&type=template&id=5203c3ec"
import script from "./grid-column.vue?vue&type=script&lang=js"
export * from "./grid-column.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__